module.exports = __webpack_public_path__ + "img/model_29_ug.6f6e2ce6.jpg";